import { render, staticRenderFns } from "./TicketSetting.vue?vue&type=template&id=14fd9a9e&"
import script from "./TicketSetting.vue?vue&type=script&lang=js&"
export * from "./TicketSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports